import React, { useState } from "react";

import css from "./MealsComponent.module.css";
import { ButtonCreate } from "../../../ui/ButtonCreate/ButtonCreate";
import { MealsListComponent } from "../MealsListComponent/MealsListComponent";
import MealCreateModal from "../settingSectionModals/MealCreateModal/MealCreateModal";
import MealUpdateModal from "../settingSectionModals/MealUpdateModal/MealUpdateModal";

const MealsComponent = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenUpdate, setIsOpenUpdate] = useState(false);

  const handleClick = () => {
    setIsOpen(true);
  };

  return (
    <section className={css.wrap}>
      <section className={css.btnBlock}>
        <ButtonCreate onClick={handleClick} />
      </section>

      <section className={css.listBlock}>
        <MealsListComponent />
      </section>

      {isOpen && <MealCreateModal setIsOpen={setIsOpen} />}
      {isOpenUpdate && <MealUpdateModal setIsOpenUpdate={setIsOpenUpdate} />}
    </section>
  );
};

export { MealsComponent };
